<template>
  <div class="settings-item-box">
    <div
      v-if="header"
      class="ibf-h2 settings-item-box--header"
    >
      {{ header }}
    </div>
    <div
      v-if="subtitle"
      :class="`${subtitleClass} settings-item-box--subtitle`"
    >
      {{ subtitle }}
    </div>
    <!-- <p>settings-item-box</p> -->
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    subtitleClass: {
      type: String,
      default: 'ibf-text-list3 settings-item-box--subtitle-color',
    },
    header: {
      type: String,
    },
    subtitle: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-item-box--subtitle-color {
  color: $-text-text-low-old !important;
}
.settings-item-box--header {
  color: $-text--dark;
  margin-bottom: 8px;
}
.settings-item-box--subtitle {
  color: $-text--dark;
  font-size: 12px;
}
.settings-item-box {
  padding: 16px;
  border: 1px solid $-system-app-grey-95;
}
</style>
